// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Documentos_CriarreciboInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /documentos/criarRecibo
 *
 * Validates input for creating a receipt PDF from HTML content.
 */
import { registerContract } from './validate'

export interface Documentos_CriarreciboInput {
HTML: string
owner_id: number
}

registerContract('Documentos_CriarreciboInput', {
  HTML:     { type: 'string',  required: true },
  owner_id: { type: 'number',  required: true },
})
